module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ3_3.f2f5cd82.svg";